import { useCallback, useContext, useRef, useState } from 'react';
import { CheckoutContext } from '@/context/CheckoutContext';
import { AdyenComponentContainer } from '@/components/expressPayment/AdyenComponentContainer';
import { useAdyenApplePay } from '@/components/Wallets/AdyenApplePay/useAdyenApplePay';
import { LoaderPayButton } from '@/components/LoaderPayButton/LoaderPayButton';
import { PaymentMethodEnum } from '@/types/common';
import { useTranslate } from '@/hooks/useTranslate';
import { getZipCodeErrorMessageKey } from '@/utils/zipCode';
import { trackAndNotifyPaymentClick } from '@/utils/paymentClickEvents';

export const ApplePayAdyenForm = () => {
  const context = useContext(CheckoutContext);
  const {
    customer,
    payment: { isFormValid },
    actions: { setError },
  } = context;
  const { t } = useTranslate();
  const isFormValidRef = useRef(isFormValid);
  isFormValidRef.current = isFormValid;
  const [isLoading, setIsLoading] = useState(true);

  const onClick = useCallback(
    (resolve: () => void, reject: () => void) => {
      if (isFormValidRef.current) {
        trackAndNotifyPaymentClick(context, PaymentMethodEnum.APPLE_PAY);
        resolve();
      } else {
        const errorMessageKey = getZipCodeErrorMessageKey(customer ?? {});
        setError(t(errorMessageKey));
        reject();
      }
    },
    [customer, setError, t]
  );

  const handleReady = useCallback((ready?: boolean) => {
    if (ready) {
      setIsLoading(false);
    }
  }, []);

  const { applePayElement } = useAdyenApplePay({
    onClick,
    onReady: handleReady,
  });

  const showLoader = !applePayElement || isLoading;

  return (
    <div className="flex flex-col w-full min-h-11">
      <div className={`transition-opacity duration-500 ${!showLoader && 'hidden'}`}>
        <LoaderPayButton type={PaymentMethodEnum.APPLE_PAY} />
      </div>
      <div className={`transition-opacity duration-500 ${showLoader && 'hidden'}`}>
        <AdyenComponentContainer element={applePayElement} />
      </div>
    </div>
  );
};
